import { fetch } from '@/utils';
import HeadSeo from '@/components/_App/HeadSeo';
import AccessoryInner from '@/components/AccessoryInner';

import { AccessoryInnerPageInterface } from '@/types/pages/Accessory';
import { BE_ACCESSORY_PATH } from '@/constant/Paths';

export default function AccessoryInnerPage({
  accessory,
}: AccessoryInnerPageInterface) {
  return (
    <div>
      <HeadSeo
        title={accessory.title}
        description={`Buy ${accessory.title} accessory`}
      />
      <AccessoryInner {...accessory} />
    </div>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export async function getStaticProps({
  params: { id, origin },
}: {
  params: { id: string; origin: string };
}) {
  if (!id) {
    return { notFound: true };
  }

  const res = await fetch(`${BE_ACCESSORY_PATH}${id}`, undefined, origin);
  const accessory = await res.json();

  if (!accessory || !res.ok) {
    return {
      notFound: true,
    };
  }

  return {
    revalidate: 3600 * 24 * 30, // set revalidate interval of 30 days
    props: {
      accessory: accessory,
    },
  };
}
